import { Button } from "../../../utils/Utils";
import { GameVars } from "../../../GameVars";
import { AudioManager } from "../../../AudioManager";

export class MusicButtonContainer extends Phaser.GameObjects.Container {

    private audioOnButton: Button;
    private audioOffButton: Button;
    
    constructor(scene: Phaser.Scene) {

        super(scene);

        this.audioOnButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_volume_on", "btn_volume_on_hover");
        this.audioOnButton.onUp(this.onClickAudioButton, this);
        this.add(this.audioOnButton);

        this.audioOffButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_volume_off", "btn_volume_off_hover");
        this.audioOffButton.onUp(this.onClickAudioButton, this);
        this.add(this.audioOffButton);

        if (GameVars.gameData.musicMuted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }
    }

    private onClickAudioButton(): void {

        AudioManager.playSound("click");

        AudioManager.toggleMusicState();

        if (GameVars.gameData.musicMuted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }
    }
}
